module.exports = __webpack_public_path__ + "static/media/img_socialmedia-05TT.8a49359d.png";